import {DictionaryKey} from "../common/types/dictionary-key-type";
import {NullableUndefinedString} from "../common/types/nullable-types";


if (!Array.prototype.toDictionary) {
    Array.prototype.toDictionary = function<TItem, TKey extends DictionaryKey, TValue>(keySelector: (item: TItem, index: number) => TKey,
                                                                 valueSelector?: (item: TItem, index: number) => TValue | TItem ): Record<NullableUndefinedString, TValue | TItem> {
        const result: Record<NullableUndefinedString, TValue | TItem> = {};

        if(!valueSelector) {
            valueSelector = (item) => item;
        }

        this.forEach((item, index) => {
            let key: any = keySelector(item, index);
            result[key] = valueSelector(item, index);
        })
        return result;
    }
}


if(!Array.prototype.groupByKey) {
    Array.prototype.groupByKey = function<TItem, TKey extends DictionaryKey, TValue>(keySelector: (item: TItem, index: number) => TKey,
                                                                     valueSelector?: (item: TItem, index: number) => TValue | TItem ): Record<NullableUndefinedString, Array<TValue | TItem>> {

        const result: Record<NullableUndefinedString, Array<TValue | TItem>> = {};

        if(!valueSelector) {
            valueSelector = (item => item);
        }

        this.forEach((item, index) => {
            const key: any = keySelector(item, index);
            if(!result[key]) {
                result[key] = [];
            }
            result[key].push(valueSelector(item, index));
        });
        return result;
    }
}

if(!Array.prototype.distinct) {
    Array.prototype.distinct = function<TItem, TKey extends DictionaryKey, TResult>(keySelector?: (item: TItem, index: number) => TKey | TItem,
                                                                                    valueSelector?: (item: TItem, index: number) => TResult | TItem): Array<TItem | TResult> {
        if(this.length === 0) {
            return [];
        }

        if(!keySelector) {
            keySelector = item => item;
        }

        if(!valueSelector) {
            valueSelector = item => item;
        }

        const uniqueItems: Record<NullableUndefinedString, TResult | TItem> = {};

        this.forEach((item, index) => {
            const key: any = keySelector(item, index);
            uniqueItems[key] = valueSelector(item, index);
        })

        return Object.values(uniqueItems);
    }
}

if(!Array.prototype.all) {
    Array.prototype.all = function<T>(predicate: (item: T) => boolean): boolean {
        if(this.length === 0) {
            return false;
        }

        for(let item of this) {
            if(!predicate(item)) {
                return false;
            }
        }
        return true;
    }
}

if(!Array.prototype.splitToChunks) {
    Array.prototype.splitToChunks = function<T>(chunkSize: number): Array<T[]> {
        if(this.length === 0) {
            return [];
        }

        let result: Array<T[]> = [];
        for(let i = 0; i * chunkSize < this.length; i++) {
            result.push(this.slice(i * chunkSize, i * chunkSize + chunkSize));
        }

        return result;
    }
}

if(!Array.prototype.selectMany) {
    Array.prototype.selectMany = function<TItem, TValue>(subItemsSelector: (item: TItem, index: number) => TValue[]): TValue[] {

        const result: TValue[] = [];
        this.forEach((item, index) => {
            for(let value of subItemsSelector(item, index)) {
                result.push(value);
            }
        });
        return result;
    }
}

if (!Array.prototype.findFirst) {
    Array.prototype.findFirst = function<T>(filter: (item: T) => boolean): T | undefined {
        return this.filter(filter)[0];
    }
}

if (!Array.prototype.max) {
    Array.prototype.max = function<T>(valueSelector: (item: T) => number): T | undefined {
        if(this.length === 0) {
            return undefined;
        }

        let max = this[0];

        for(let i = 1; i < this.length; i++) {
            if(valueSelector(max) < valueSelector(this[i])) {
                max = this[i];
            }
        }

        return max;
    }
}

if (!Array.prototype.min) {
    Array.prototype.min = function<T>(valueSelector: (item: T) => number): T | undefined {
        if(this.length === 0) {
            return undefined;
        }

        let min = this[0];

        for(let i = 1; i < this.length; i++) {
            if(valueSelector(min) > valueSelector(this[i])) {
                min = this[i];
            }
        }

        return min;
    }
}

if(!Array.prototype.sum) {
    Array.prototype.sum = function<T>(valueSelector: (item: T) => number): number {
        if(this.length === 0) {
            return 0;
        }
        let result = 0;
        this.forEach(item => {
            result += valueSelector(item);
        });

        return result;
    }
}


export {};
